import { getClosestIndex } from '@components/gassan-ui/Slider/getClosestIndex'
import { MutableRefObject, useEffect } from 'react'

export function useProductSlider(
  ref: MutableRefObject<HTMLDivElement>,
  activeIndex: number,
  slideLength: number,
  setIndex: (index: number) => void,
) {
  useEffect(() => {
    if (ref && ref.current) {
      ref.current.scrollTo({
        top: 0,
        left: activeIndex * ref.current.clientWidth,
        behavior: 'smooth',
      })
    }
  }, [activeIndex, ref])

  useEffect(() => {
    const slideContainer = ref.current
    if (!slideContainer) return

    const handleScrollEnd = () => {
      if (slideContainer) {
        const closestIndex = getClosestIndex(ref.current)

        setIndex(closestIndex)
      }
    }

    slideContainer.addEventListener('scrollend', handleScrollEnd)

    return () => {
      slideContainer.removeEventListener('scrollend', handleScrollEnd)
    }
  })

  const handlePrev = () => setIndex(activeIndex === 0 ? slideLength - 1 : activeIndex - 1)
  const handleNext = () => setIndex(activeIndex === slideLength - 1 ? 0 : activeIndex + 1)

  return { handlePrev, handleNext }
}
